import styled from 'styled-components'
import { colors } from '../../../../../styles/constants'

export const Container = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  margin-top: 48px;
  border-radius: 16px;
  border: 1px solid ${colors.gray.default};
`
export const WrapperHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`
export const Title = styled.h4`
  color: #747576;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`
export const Clip = styled.p`
  font-family: Open Sans;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #CE9400;
  display: flex;
  padding: 2px 8px 3px 8px;
  align-items: flex-start;
  border-radius: 8px;
  margin: 0;
  background: #FAECCA;
`
export const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const TitleHistory = styled.h4`
  color: #747576;
  text-align: center;
  font-family: Open Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 16px 0px 0px;
`
export const SubtitleHistory = styled.p`
  color: #747576;
  text-align: center;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 16px 0px;
`
export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
`
